import moment from 'moment';

export const formatDate = (value?: string) =>
  value ? moment(value).format('MMMM DD, YYYY') : '-';

export const formatFullDate = (value?: string) =>
  value ? moment(value).format('dddd MMMM DD, YYYY hh:mm A') : '-';
